import { defineStore } from "pinia";

export const useEvaluationFrameworkStore = defineStore('evaluationFramework', {
    state: () => ({
        evaluationFramework: {},
        evaluationFrameworks: [],
    }),
    actions: {
        setEvaluationFramework(evaluationFramework) {
            this.evaluationFramework = evaluationFramework
        },
        setEvaluationFrameworks(evaluationFrameworks) {
            this.evaluationFrameworks = evaluationFrameworks
        },
        addEvaluationFramework(evaluationFramework) {
            this.evaluationFrameworks.unshift(evaluationFramework)
        },
        updateEvaluationFramework(evaluationFramework) {
            let index = this.evaluationFrameworks.findIndex(cl => cl.id === evaluationFramework.id)
            this.evaluationFrameworks.splice(index, 1, evaluationFramework)
        },
        deleteEvaluationFramework(evaluationFramework) {
            let index = this.evaluationFrameworks.findIndex(cl => cl.id === evaluationFramework.id)
            this.evaluationFrameworks.splice(index, 1)
        },
    },
});